import React, { useEffect, useState, useRef } from 'react';
import Footer from '../../../components/Footer';
import Header from '../../../components/Header';
import Select from 'react-select';
import { useCustomSnackbar } from '../../../hooks/useCustomSneakbar';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../../../hooks/useAuthorizedRequest';
import { generateAxiosInstanceCommonFileUpload } from '../../../hooks/useAuthorizedRequestForFileUpload';
import { CModal } from '@coreui/react';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../../components/ModalsCommonFunctions';
import Pagination from '../../../components/Pagination';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../../../components/Navigation';

const LiteracyGame = () => {
    const authorizedAxios = generateAxiosInstance()
    const authorizedAxiosCommonFileUpload = generateAxiosInstanceCommonFileUpload()
    const [formData, setFormData] = useState([])
    const inputRef = useRef(null);

    const initialFormState = {
        filePath: '',
        fileName: '',
        title: '',
        description: '',
        tagMasterId: '',
        gradeMasterIds: [''],
        streamOrMediumMasterId: '',
        boardMasterId: ''
    }
    const [inputpdf, setInputPdf] = useState({ value: '' })

    const [PdfBookData, setPdfBookData] = useState(initialFormState)
    const [PdfBookList, setPdfBookList] = useState([])
    const [editId, setEditId] = useState(null)
    const [visible, setVisible] = useState(false)
    const [showPdfLink, setShowPdfLink] = useState("")
    const [tag, setTag] = useState([])

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);
    const [refresh, setRefresh] = useState(true);
    const [addNew, setAddNew] = useState(false);

    const [boardSort, setBoardSort] = useState(null);
    const [mediumSort, setMediumSort] = useState(null);
    const [pdfTitleSort, setPdfTitleSort] = useState(null);
    const [pdfDescriptionSort, setPdfDescriptionSort] = useState(null);
    const [tagNameSort, setTagNameSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["boardMasterDetails.boardName", "streamOrMediumMasterDetails.streamName", "referenceBookMasterDetails.gradeMasterDetails.gradeName", "fileName", "title", "description", "tagMasterDetails.tagName"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            setRefresh(!refresh);
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            if (PdfBookData.boardMasterId.length !== 0) {
                setCurrPage(1);
                setPdfBookList(await searchArray("A", getApiUrl(), searchKeys, searchValue.trim()))
            }
        }
    }

    useEffect(() => {
        getPdfBookListDelete();
    }, [PdfBookData]);

    const getApiUrl = () => {
        let apiUrl = '/get-reference-book?';

        if (PdfBookData.tagMasterId !== '') {
            apiUrl += `tagMasterId=${PdfBookData.tagMasterId}&`;
        }
        if (PdfBookData.boardMasterId !== '') {
            apiUrl += `boardMasterId=${PdfBookData.boardMasterId}&`;
        }
        if (PdfBookData.streamOrMediumMasterId !== '') {
            apiUrl += `streamOrMediumMasterId=${PdfBookData.streamOrMediumMasterId}&`;
        }
        if (PdfBookData.gradeMasterIds.length != 0) {
            apiUrl += `gradeMasterIds=${PdfBookData.gradeMasterIds}&`;
        }

        apiUrl = apiUrl.replace(/&$/, '');
        return apiUrl;
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(PdfBookList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId, addNew])

    useEffect(() => {
        setTotalPages(Math.ceil(PdfBookList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > PdfBookList.length) {
            endIndex = PdfBookList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(PdfBookList.slice(startIndex, endIndex));
    }, [PdfBookList, currPage, itemsPerPage]);

    const getPdfBookList = async () => {
        if (PdfBookData.boardMasterId !== '') {
            try {
                let apiUrl = getApiUrl();
                const response = await authorizedAxios.get(apiUrl);
                setPdfBookList(response.data.result);
                setAddNew(!addNew);
            } catch (error) {
                setPdfBookList(error?.response?.data.result);
                console.error('Error fetching data:', error);
            }
        }
    }

    const getPdfBookListDelete = async () => {
        if (PdfBookData.boardMasterId !== '') {
            try {
                let apiUrl = getApiUrl();
                const response = await authorizedAxios.get(apiUrl);
                setPdfBookList(response.data.result);
            } catch (error) {
                setPdfBookList(error?.response?.data.result);
                console.error('Error fetching data:', error);
            }
        }
    }

    useEffect(() => {
        getSyllabusStructure();
        getFlnTagMaster();
    }, []);

    const getSyllabusStructure = () => {
        const apiUrl = `/get-data-for-syllabus-structure-master`;
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setFormData(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const getFlnTagMaster = () => {
        const apiUrl = `/fln-tag`;
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setTag(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleInputChange = (e) => {
        setPdfBookData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value
            }
        })
    }

    const initialErrorState = {

    }

    const [error, setError] = useState(initialErrorState)
    const validateForm = () => {
        return Object.values(error).every((error) => error === '') && Object.values(PdfBookData).every((value) => typeof (value) == "string" ? value !== '' : value.length !== 0)
    };

    useEffect(() => {
        if (!Object.values(error).every((error) => error === '')) {
            for (const [key, value] of Object.entries(PdfBookData)) {
                if (value == '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }, [PdfBookData])

    const addLesson = async () => {
        if (validateForm()) {
            try {
                setLoading(true);
                const apiUrl = `/add-reference-book`;
                const response = await authorizedAxios.post(apiUrl, PdfBookData);
                await getPdfBookList();
                setRefresh(!refresh);
                inputRef.current.value = '';
                setPdfBookData((prevData) => {
                    return {
                        ...prevData,
                        filePath: '',
                        fileName: '',
                        title: '',
                        description: ''
                    }
                });

                // setPdfBookList(response.data.result);
                setSaveId(response.data.result.id);
                setBoardSort(null);
                setMediumSort(null);
                setPdfTitleSort(null);
                setPdfDescriptionSort(null);
                setTagNameSort(null);

                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        } else {
            for (const [key, value] of Object.entries(PdfBookData)) {
                if (value === '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }

    const deleteLesson = async (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            try {
                setLoading(true);
                const apiUrl = `/delete-reference-book?id=${id}`;
                const response = await authorizedAxios.delete(apiUrl);
                const page = deleteItem(currPage, itemsPerPage, PdfBookList.length);
                await getPdfBookListDelete();
                setCurrPage(page);
                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        }
    }

    const handleUploadLogo = async (e) => {
        const file = e.target.files[0];
        let fileName = file.name.split(".")[0]
        setInputPdf(e.target)
        let fileExtention = file.name.split(".").pop()
        const body = new FormData();
        body.append("file", file);
        body.append("flag", "2"); //2 -> content path in s3 bucket

        if (fileExtention == "pdf") {
            if (file.size < 50 * 1024 * 1024) {
                setLoading(true);
                const apiUrl = "uploadfile-v2";
                authorizedAxiosCommonFileUpload && authorizedAxiosCommonFileUpload.post(apiUrl, body)
                    .then((res) => {
                        setPdfBookData((prevData) => {
                            return {
                                ...prevData,
                                [e.target.name]: res.data.result,
                                fileName: fileName
                            }
                        })
                    })
                    .catch((err) => {
                        const errorMsg = err.response.data.error || "Something went wrong!";
                        Swal.fire({
                            text: errorMsg
                        })
                    })
                    .finally(() => {
                        setLoading(false); // End loading
                    });
            } else {
                e.target.value = ''
                Swal.fire(
                    { text: "max size 30 mb file supported" }
                );
            }
        } else {
            e.target.value = ''
            Swal.fire(
                { text: " Only pdf file supported" }
            );
        }
    }

    const ClassList = formData?.gradeData?.map((sub) => {
        return {
            value: sub.id,
            label: sub.gradeName
        }
    }) || [];

    const handleChangeBoard = (selectedOptions) => {
        const selectedIds = selectedOptions.map((option) => option.value.toString());
        setPdfBookData((prevData) => {
            return {
                ...prevData,
                gradeMasterIds: selectedIds,
            }
        })
    }

    useEffect(() => {
        if (boardSort == true || boardSort == false) {
            setMediumSort(null);
            setPdfTitleSort(null);
            setPdfDescriptionSort(null);
            setTagNameSort(null);
        }
    }, [boardSort])

    useEffect(() => {
        if (mediumSort == true || mediumSort == false) {
            setBoardSort(null);
            setPdfTitleSort(null);
            setPdfDescriptionSort(null);
            setTagNameSort(null);
        }
    }, [mediumSort])

    useEffect(() => {
        if (pdfTitleSort == true || pdfTitleSort == false) {
            setBoardSort(null);
            setMediumSort(null);
            setPdfDescriptionSort(null);
            setTagNameSort(null);
        }
    }, [pdfTitleSort])

    useEffect(() => {
        if (pdfDescriptionSort == true || pdfDescriptionSort == false) {
            setBoardSort(null);
            setMediumSort(null);
            setPdfTitleSort(null);
            setTagNameSort(null);
        }
    }, [pdfDescriptionSort])

    useEffect(() => {
        if (tagNameSort == true || tagNameSort == false) {
            setBoardSort(null);
            setMediumSort(null);
            setPdfTitleSort(null);
            setPdfDescriptionSort(null);
        }
    }, [tagNameSort])

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Game</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa fa-upload"></i>Game</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Board :</label>
                                                    <select class="form-select" disabled={editId} aria-label="Default select example" name='boardMasterId' onChange={handleInputChange} value={PdfBookData.boardMasterId}>
                                                        <option selected value={''} disabled>Select Board</option>
                                                        {
                                                            formData?.boardData?.map((board) => {
                                                                return <option value={board.id}>{board.boardName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.boardMasterId && <p style={{ color: 'red' }}>{error.boardMasterId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Medium :</label>
                                                    <select class="form-select" disabled={editId} aria-label="Default select example" name='streamOrMediumMasterId' onChange={handleInputChange} value={PdfBookData.streamOrMediumMasterId}>
                                                        <option selected value={''} disabled>Select Medium</option>
                                                        {
                                                            formData?.streamOrMediumData?.map((stream) => {
                                                                return <option value={stream.id}>{stream.streamName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.streamOrMediumMasterId && <p style={{ color: 'red' }}>{error.streamOrMediumMasterId}</p>}

                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Class :</label>
                                                    <Select
                                                        value={ClassList.filter(option =>
                                                            PdfBookData.gradeMasterIds && PdfBookData.gradeMasterIds.includes(option.value.toString())
                                                        )}
                                                        isMulti
                                                        name="gradeMasterIds"
                                                        options={ClassList}
                                                        className="basic-multi-select"
                                                        classNamePrefix="Select Board"
                                                        onChange={handleChangeBoard}
                                                    />
                                                    {error.gradeMasterIds && <p style={{ color: 'red' }}>{error.gradeMasterIds}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select FLN Tag :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='tagMasterId' onChange={handleInputChange} value={PdfBookData.tagMasterId}>
                                                        <option selected value={''} disabled>Select FLN Tag</option>
                                                        {
                                                            tag?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus.tagName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.tagMasterId && <p style={{ color: 'red' }}>{error.tagMasterId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Upload Game :</label>
                                                    <label style={{ color: "red" }} > max 50 Mb game file supported</label>
                                                    <input required type="file" className="form-control" name="filePath" onChange={handleUploadLogo} ref={inputRef} />
                                                    {error.filePath && <p style={{ color: 'red' }}>{error.filePath}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>File Name:</label>
                                                    <input required type="text" className="form-control" name="fileName" value={PdfBookData.fileName} onChange={handleInputChange} />
                                                    {error.fileName && <p style={{ color: 'red' }}>{error.fileName}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Title:</label>
                                                    <input required type="text" className="form-control" name="title" value={PdfBookData.title} onChange={handleInputChange} />
                                                    {error.title && <p style={{ color: 'red' }}>{error.title}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Description:</label>
                                                    <input required type="text" className="form-control" name="description" value={PdfBookData.description} onChange={handleInputChange} />
                                                    {error.description && <p style={{ color: 'red' }}>{error.description}</p>}
                                                </div>
                                            </div>
                                            <CModal
                                                visible={visible}
                                                onClose={() => setVisible(false)}
                                                aria-labelledby="LiveDemoExampleLabel"
                                            >
                                                <div className="book pdf-modal">
                                                    {<iframe src={showPdfLink} width="800" height="1000"></iframe>}
                                                    <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => setVisible(false)}>
                                                        Close
                                                    </button>
                                                </div>
                                            </CModal>

                                            <div className="row">
                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                    <div className="col-auto">
                                                        {!editId && <button className="btn btn-primary" type="button" style={{ marginRight: '20px' }} onClick={addLesson}>Save</button>
                                                        }
                                                        <button className="btn btn-outline-danger delete_icon" type="reset" style={{ marginRight: '20px' }} onClick={() => { setPdfBookList([]); setEditId(''); inputpdf.value = ''; setPdfBookData(initialFormState); inputRef.current.value = '' }}>Reset</button>
                                                    </div>
                                                </div>

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>

                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">
                                                                            Board
                                                                            <SortIcon sortState={boardSort} setSortState={setBoardSort} setData={setPdfBookList} setCurrPage={setCurrPage} sortingPath={"boardMasterDetails.boardName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Medium
                                                                            <SortIcon sortState={mediumSort} setSortState={setMediumSort} setData={setPdfBookList} setCurrPage={setCurrPage} sortingPath={"streamOrMediumMasterDetails.streamName"} />
                                                                        </th>
                                                                        <th scope="col">Class</th>
                                                                        <th scope="col">
                                                                            Tag Name
                                                                            <SortIcon sortState={tagNameSort} setSortState={setTagNameSort} setData={setPdfBookList} setCurrPage={setCurrPage} sortingPath={"tagMasterDetails.tagName"} />
                                                                        </th>
                                                                        <th scope="col">Pdf Name</th>
                                                                        <th scope="col">
                                                                            Pdf Title
                                                                            <SortIcon sortState={pdfTitleSort} setSortState={setPdfTitleSort} setData={setPdfBookList} setCurrPage={setCurrPage} sortingPath={"title"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Pdf Description
                                                                            <SortIcon sortState={pdfDescriptionSort} setSortState={setPdfDescriptionSort} setData={setPdfBookList} setCurrPage={setCurrPage} sortingPath={"description"} />
                                                                        </th>
                                                                        <th scope="col">Pdf</th>
                                                                        <th scope="col">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData.length > 0 ?
                                                                            displayedData.map((lesson, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{lesson.boardMasterDetails.boardName}</td>
                                                                                        <td>{lesson.streamOrMediumMasterDetails.streamName}</td>
                                                                                        <td>{lesson.referenceBookMasterDetails.map((i) => `${i.gradeMasterDetails.gradeName}`).join(", ")}</td>
                                                                                        <td>{lesson?.tagMasterDetails?.tagName}</td>
                                                                                        <td>{lesson.fileName}</td>
                                                                                        <td>{lesson.title}</td>
                                                                                        <td>{lesson.description}</td>
                                                                                        <td>
                                                                                            <button className="btn btn-primary view_icon" type="button" onClick={() => {
                                                                                                setShowPdfLink(lesson.filePath)
                                                                                                setVisible(true)
                                                                                            }}><i class="fa fa-eye" ></i> PDF</button>
                                                                                        </td>
                                                                                        <td>
                                                                                            <button className="btn btn-outline-danger delete_icon" type="button" onClick={() => deleteLesson(lesson.id)}> <i class="fa-light fa-trash-can"></i></button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Reference Books Available</th>
                                                                            </tr>)
                                                                    }

                                                                </tbody>
                                                            </table>
                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={PdfBookList.length} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default LiteracyGame;